<template>
  <div id="app">
    <transition :name="transitionName">
      <!-- :include="$store.state.app.keepInclude" -->
      <keep-alive :include="$store.state.app.keepInclude">
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import {
  apiBaseUrl,
  baseUrl
} from "@/utils/common";
export default {
  name: "App",
  data() {
    return {
      isStopPage: true,
      transitionName: "",
      isShowMap: false,
      intervalTime: "", // 定时器
      pageId: "" // 当前页面的id
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        // if (to.path == "/manager/fourhundredPage" || to.path == "/manager/examplePage" || (to.name == null && location.href.indexOf("/manager/fourhundredPage") != -1) || (to.name == null && location.href.indexOf("/manager/examplePage") != -1)) {
        //   console.log("放行，设置为所有用户可进入的页面");
        //   this.isStopPage = false;
        // } else {
        //   this.isStopPage = true;
        // }
        clearInterval(this.intervalTime);
        this.pageId = "";
        if (localStorage.getItem("isBack") == "false") {
          this.transitionName = "slide-left";
        } else if (localStorage.getItem("isBack") == "true") {
          this.transitionName = "slide-right";
        } else if (localStorage.getItem("isBack") == "") {
          this.transitionName = "slide-coustom"; // 没有任何动画效果的类名
        }
        localStorage.setItem("isBack", "");
      // this.recordPage();
      },
      immediate: true, // 值为true或false，默认false
      deep: true
    }
  },
  created() {

  },
  mounted() {
    // userType为 1 终端用户 2 客户经理
    let userType = this.getQueryVariable("usertype") || "";
    let orderlistuid = this.getQueryVariable("orderlistuid") || "";  // 订单id 终端用户所需
    let customernormaluid = this.getQueryVariable("customernormaluid") || "";  // 用户id 终端用户所需
    let productuid = this.getQueryVariable("productuid") || "";  // 产品id 终端用户所需
    // 测试openid owTqr1UkLPgD5Bd4BESWgHdVYgXg
    let openid = this.getQueryVariable("openid") || "";  // openid 所有用户都需要
    let userWxname = this.getQueryVariable("weichatname") || "";  // 微信昵称 所有用户都需要

    // 先存入链接获取到的基本信息
    // localStorage.setItem("customernormaluid", customernormaluid);
    localStorage.setItem("openid", openid);
    localStorage.setItem("userWxname", userWxname);

    if (userType == 1) {
      localStorage.setItem("userType", "customer");
      localStorage.setItem("productuid", productuid);
      if (orderlistuid && orderlistuid != "") {
        localStorage.setItem("orderlistuid", orderlistuid);
      }
      localStorage.setItem("customernormaluid", customernormaluid);
      if (!customernormaluid || customernormaluid == "") {
      // 授权操作是直接访问腾讯开放平台的一个授权地址，授权成功后会回调
        window.location = apiBaseUrl + "/wxauth/wxAuthLogin?redirect_uri=" + apiBaseUrl + "/wxauth/callback/" + orderlistuid + "?successurl=" + baseUrl + "/customer";
      }
      this.$router.push("/customer");
      // localStorage.setItem("openid", openid); !!!!!!!!!!!!!!!!!!!!!!!!!!!2023/03/23注释
    } else if (userType == 2 || userType == "" || !userType) {
      localStorage.setItem("userType", "manager");
      if (!localStorage.getItem("openid") || localStorage.getItem("openid") == null || localStorage.getItem("openid") == undefined || localStorage.getItem("openid") == "") {
        let sysuserid = this.getQueryVariable("sysuserid") || "";
        let registertype = this.getQueryVariable("registertype") || "";
        let customeruid = this.getQueryVariable("customeruid") || "";
        let arrivePath = window.location.href.split("#")[1] || "";  // 截取要跳转的vue页面路由 主要用于客户经理部分页面需要直接跳转进入
        localStorage.setItem("arrivePath", arrivePath);

        window.location = apiBaseUrl + "/wxauth/wxAuthLogin?redirect_uri=" + this.urlencode(apiBaseUrl + "/wxauth/callbackInfo?successurl=" + baseUrl + "&sysuserid=" + sysuserid + "&registertype=" + registertype + "&customeruid=" + customeruid + "#" + arrivePath);
      }
    } else {
      localStorage.setItem("userType", "manager");
      if (!localStorage.getItem("openid") || localStorage.getItem("openid") == null || localStorage.getItem("openid") == undefined || localStorage.getItem("openid") == "") {
        let sysuserid = this.getQueryVariable("sysuserid") || "";
        let registertype = this.getQueryVariable("registertype") || "";
        let customeruid = this.getQueryVariable("customeruid") || "";
        let arrivePath = window.location.href.split("#")[1] || "";  // 截取要跳转的vue页面路由 主要用于客户经理部分页面需要直接跳转进入

        localStorage.setItem("arrivePath", arrivePath);

        window.location = apiBaseUrl + "/wxauth/wxAuthLogin?redirect_uri=" + this.urlencode(apiBaseUrl + "/wxauth/callbackInfo?successurl=" + baseUrl + "&sysuserid=" + sysuserid + "&registertype=" + registertype + "&customeruid=" + customeruid + "#" + arrivePath);
      }
    }
    console.log(window.location.href);
    // 不知道这一步要干嘛
    // if (this.isStopPage) {
    //   console.log(localStorage.getItem("arrivePath"));
    //   let newpath = localStorage.getItem("arrivePath") || "/";
    //   this.$router.push(newpath);
    // }
    // 终端用户登录 直接设置微信分享相关信息
    if (customernormaluid && customernormaluid != "") {
      const self = this;
      setTimeout(() => {
      // 微信sdk引入 配置对应项 分享功能
        let link = location.href.split("#")[0];
        // 获取用户openId
        // self.getOpenId(link); !!!!!!!!!!!!!!!!!!!!!!!!!!!2023/03/23注释
        // 微信配置
        self.$request.wxGetSign({
          url: link
        }).then(res => {
          self.$wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId,
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "chooseWXPay"]
          });
          self.$wx.ready(function() {
            self.$wx.onMenuShareAppMessage({
              title: "企业彩铃、视频彩铃、400电话", // 分享标题
              desc: "开通产品，拿奖励；发展成员，拿分红", // 分享描述
              link: link, // 分享链接
              imgUrl: baseUrl + "/projectimg/newlogo.png" // 分享图标
            });
            self.$wx.onMenuShareTimeline({
              title: "企业彩铃、视频彩铃、400电话", // 分享标题
              desc: "开通产品，拿奖励；发展成员，拿分红", // 分享描述
              link: link, // 分享链接
              imgUrl: baseUrl + "/projectimg/newlogo.png" // 分享图标
            });
          });
          self.$wx.error(function(res) {
          // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
            this.$toast(res);
          });
        }).catch(err => {
          self.$toast(err);
        });
      }, 3000);
    }
  },
  methods: {
    // urlencode转码
    urlencode(str) {
      str = (str + "").toString();

      return encodeURIComponent(str).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28")
        .replace(/\)/g, "%29").replace(/\*/g, "%2A").replace(/%20/g, "+");
    },
    // 获取参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0;i < vars.length;i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
      }
      return (false);
    },
    getURLQueryString(name) {
      var url = decodeURIComponent(window.location.href);
      url = url.replace(/&quot/g, "\"");
      var r;
      if (url.indexOf("#?") > 0) {
        url = url.replace("#?", "&");
        r = url.match(new RegExp("(^|&)" + name + "=([^&]*)(&|$)"));
      } else {
        r = window.location.search.substr(1).match(new RegExp("(^|&)" + name + "=([^&]*)(&|$)"));
      }
      return r ? r[2] : null;
    },
    // 获取openid
    getOpenId(url) {
      if (!localStorage.getItem("openid") || localStorage.getItem("openid") == "") {
        let then = this;
        this.$request.getOpenId({
          redirect_uri: url
        }).then(res => {
          if (res.code == 200) {
            localStorage.setItem("openid", res.data.openid);
          } else {
            if (res) {
              let errMsg = res.msg + "code:" + res.code;
              then.$toast(errMsg);
            }
          }
        }).catch(err => {
          then.$toast(err);
        });
      }
    },
    recordPage() {
      this.intervalTime = setInterval(() => {
        // this.immediately();
      }, 5000);
    }
  }
};
</script>

<style>
html,
body {
  position: relative;
  width: 100%;
  height: 100%;
  user-select: none;
  -webkit-user-select: none;
  background: #f5f5f5;
  overflow: hidden;
}
li {
  list-style: none;
}
input {
  padding: 0;
  margin: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  position: relative;
  font-size: 0.3rem;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active,
.slide-coustom-enter-active,
.slide-coustom-leave-active {
  will-change: transform;
  transition: all 0.3s ease-in-out;
  position: absolute;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.slide-left-enter + div[class*="slide-coustom"] {
  display: none;
}

.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}

.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}

.slide-left-enter {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}

.slide-left-leave-active {
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}

.czcCenterCss {
  display: flex;
  justify-content: center;
  align-items: center;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999999;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999999;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999999;
}

input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999999;
}

::-webkit-input-placeholder {
  font-size: 0.22rem;
  font-weight: 400;
  color: #999999;
}

.ios-bottom {
  padding-bottom: env(safe-area-inset-bottom);
}

</style>



// WEBPACK FOOTER //
// src/App.vue